import { useT } from './i18n.ts'

/**
 * "여기부터 읽지 않음" 가로줄.
 *
 * ## 이 줄이 왜 중요한가
 * 채널을 열었을 때 **맨 아래가 아니라 이 줄로** 스크롤해야 한다. 맨 아래로 보내면
 * 사람은 안 읽은 것을 위로 긁어 올려 찾아야 하고, 그 과정에서 읽음 표시가
 * 먼저 올라가 버린다 — 그러면 다음에 열었을 때 아무것도 안 남는다.
 */
export function UnreadLine({ count }: { count: number }) {
  const t = useT()
  if (count <= 0) return null
  return (
    // `role="separator"` 를 얹은 div 가 아니라 진짜 `<hr>` 이다.
    // 보조 기술이 이미 아는 요소를 쓰면 역할을 설명할 필요가 없다.
    <div className="UnreadLine">
      <hr aria-label={t('읽지 않은 메시지 {n}개', { n: count })} />
      <span>{t('새 메시지 {n}개', { n: count })}</span>
    </div>
  )
}
